module.exports = __webpack_public_path__ + "static/media/wa.7f584fa0.png";